"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

// Fake loadingProgress with setInterval
var useTestLoadingProgress = function useTestLoadingProgress(visible, isLong, noLoad) {
  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      loadingProgress = _useState4[0],
      setLoadingProgress = _useState4[1];

  var timerRef = (0, _react.useRef)();
  var clearTimer = (0, _react.useCallback)(function () {
    clearInterval(timerRef.current);
    timerRef.current = null;
  }, []);
  (0, _react.useEffect)(function () {
    if (visible && !noLoad) {
      setIsLoading(true);
      var progress = 0;
      timerRef.current = setInterval(function () {
        progress += isLong ? 20 : 40;

        if (progress >= 100) {
          clearTimer();
          setIsLoading(false);
        }

        setLoadingProgress(progress > 100 ? 100 : progress);
      }, 200);
    } else {
      setLoadingProgress();
      clearTimer();
    }

    return clearTimer;
  }, [clearTimer, isLong, noLoad, visible]);
  return {
    loadingProgress: loadingProgress,
    isLoading: noLoad ? false : isLoading
  };
};

var _default = useTestLoadingProgress;
exports["default"] = _default;
//# sourceMappingURL=useTestLoadingProgress.js.map